export default __webpack_public_path__ + "static/media/STL_Fiscal_23.a7058b7d.pdf";